import { InstanceStatus } from '../types/instance';

const STATUS_STYLES: Record<InstanceStatus, string> = {
  [InstanceStatus.RUNNING]: 'bg-green-100 text-green-700',
  [InstanceStatus.PAUSED]: 'bg-yellow-100 text-yellow-700',
  [InstanceStatus.STARTING]: 'bg-blue-100 text-blue-700',
  [InstanceStatus.PENDING]: 'bg-blue-100 text-blue-700',
  [InstanceStatus.COMPLETED]: 'bg-slate-100 text-slate-600',
  [InstanceStatus.STOPPED]: 'bg-slate-100 text-slate-600',
  [InstanceStatus.FAILED]: 'bg-red-100 text-red-700',
};

interface InstanceStatusBadgeProps {
  status: InstanceStatus;
}

export default function InstanceStatusBadge({ status }: InstanceStatusBadgeProps) {
  return (
    <span
      className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium capitalize ${STATUS_STYLES[status] ?? 'bg-slate-100 text-slate-600'}`}
    >
      {status}
    </span>
  );
}
